import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';
/**
 * Tizim sozlamalari.
 *
 * KALITLAR RO'YXATI SHU YERDA, kod ularni nomi bilan o'qiydi. Admin
 * YANGI kalit o'ylab topa olmaydi — u faqat mavjudining qiymatini
 * o'zgartiradi. Aks holda bazada hech kim o'qimaydigan sozlamalar
 * to'planib qolardi (`Permission` bilan bir xil yondashuv).
 *
 * Seed ham SHU RO'YXATDAN to'ldiriladi — ikki joyda yozilsa ular
 * ajralib ketardi.
 */
export const SETTING_VALUE_TYPES = ['string', 'number', 'boolean'];
export const SettingValueTypeSchema = z.enum(SETTING_VALUE_TYPES);
export const SETTING_DEFINITIONS = [
    // --- brend: logo/rang kelganda yangilanadi (docs/06-OCHIQ-SAVOLLAR.md) ---
    {
        key: 'brand.name',
        valueType: 'string',
        group: 'brand',
        initial: 'AvtoPartShop',
        labelUz: 'Do‘kon nomi',
        labelRu: 'Название магазина',
        isPublic: true,
    },
    {
        key: 'brand.logo_url',
        valueType: 'string',
        group: 'brand',
        initial: '',
        labelUz: 'Logo manzili',
        labelRu: 'Адрес логотипа',
        isPublic: true,
    },
    {
        key: 'brand.is_placeholder',
        valueType: 'boolean',
        group: 'brand',
        initial: 'true',
        labelUz: 'Brend vaqtinchalik',
        labelRu: 'Бренд временный',
        hintUz: 'Haqiqiy logo va rang kelmaguncha `true`.',
        hintRu: 'Пока нет настоящего логотипа и цвета — `true`.',
    },
    // --- to'lov ---
    {
        key: 'payment.default_method',
        valueType: 'string',
        group: 'payment',
        initial: 'CASH',
        labelUz: 'Standart to‘lov usuli',
        labelRu: 'Способ оплаты по умолчанию',
    },
    {
        /*
         * ATAYLAB ochiq EMAS. Karta raqamini operator telefonda aytadi
         * (docs/02-MAHSULOT.md). Ochiq endpointga chiqarilsa, u har
         * qanday mehmonga ko'rinardi.
         */
        key: 'payment.card_number',
        valueType: 'string',
        group: 'payment',
        initial: '',
        labelUz: 'Karta raqami',
        labelRu: 'Номер карты',
        hintUz: 'Operator mijozga TELEFONDA aytadi. Ilovaga chiqarilmaydi.',
        hintRu: 'Оператор диктует клиенту ПО ТЕЛЕФОНУ. В приложение не выводится.',
    },
    {
        key: 'payment.card_owner',
        valueType: 'string',
        group: 'payment',
        initial: '',
        labelUz: 'Karta egasi',
        labelRu: 'Владелец карты',
    },
    {
        key: 'payment.card_bank',
        valueType: 'string',
        group: 'payment',
        initial: '',
        labelUz: 'Bank',
        labelRu: 'Банк',
    },
    // --- yetkazish: narx tizimda hisoblanmaydi ---
    {
        key: 'delivery.note_uz',
        valueType: 'string',
        group: 'delivery',
        initial: 'Yetkazish sharti operator bilan telefonda kelishiladi',
        labelUz: 'Yetkazish izohi (o‘zbekcha)',
        labelRu: 'Примечание о доставке (узбекский)',
        isPublic: true,
    },
    {
        key: 'delivery.note_ru',
        valueType: 'string',
        group: 'delivery',
        initial: 'Условия доставки согласуются с оператором по телефону',
        labelUz: 'Yetkazish izohi (ruscha)',
        labelRu: 'Примечание о доставке (русский)',
        isPublic: true,
    },
    // --- aloqa: bosh sahifadagi "Operator" kartochkasi. Bo'sh bo'lsa kartochka chiqmaydi ---
    {
        key: 'contact.phone',
        valueType: 'string',
        group: 'contact',
        initial: '+998 91 791 18 88',
        labelUz: 'Operator telefoni',
        labelRu: 'Телефон оператора',
        hintUz: "Masalan: +998 90 123 45 67. Bo'sh bo'lsa aloqa bloklari chiqmaydi.",
        hintRu: 'Например: +998 90 123 45 67. Если пусто — блоки связи не показываются.',
        isPublic: true,
    },
    {
        key: 'contact.telegram',
        valueType: 'string',
        group: 'contact',
        initial: 'daston_77_77',
        labelUz: 'Operator Telegram nomi',
        labelRu: 'Telegram оператора',
        hintUz: 'Faqat nom, @ belgisiz (masalan: avtopartshop_operator).',
        hintRu: 'Только имя, без @ (например: avtopartshop_operator).',
        isPublic: true,
    },
    {
        key: 'contact.hours_uz',
        valueType: 'string',
        group: 'contact',
        initial: '',
        labelUz: 'Ish vaqti (o‘zbekcha)',
        labelRu: 'Время работы (узбекский)',
        hintUz: 'Masalan: Har kuni 09:00–20:00',
        isPublic: true,
    },
    {
        key: 'contact.hours_ru',
        valueType: 'string',
        group: 'contact',
        initial: '',
        labelUz: 'Ish vaqti (ruscha)',
        labelRu: 'Время работы (русский)',
        hintRu: 'Например: Ежедневно 09:00–20:00',
        isPublic: true,
    },
    // --- buyurtma ---
    {
        key: 'order.next_number',
        valueType: 'number',
        group: 'order',
        initial: '2482',
        labelUz: 'Keyingi buyurtma raqami',
        labelRu: 'Следующий номер заказа',
        hintUz: 'Buyurtma yaratilganda avtomatik oshadi. Qo‘lda tushirilmaydi.',
        hintRu: 'Растёт автоматически при создании заказа. Вручную не уменьшается.',
    },
    // --- katalog ---
    {
        key: 'catalog.max_shipments_per_order',
        valueType: 'number',
        group: 'catalog',
        initial: '3',
        labelUz: 'Bir buyurtmadagi eng ko‘p jo‘natma',
        labelRu: 'Максимум отправлений в заказе',
    },
    {
        key: 'catalog.default_split_preference',
        valueType: 'string',
        group: 'catalog',
        initial: 'SPLIT',
        labelUz: 'Standart bo‘lish tartibi',
        labelRu: 'Порядок разделения по умолчанию',
    },
    {
        key: 'catalog.fallback_to_category_icon',
        valueType: 'boolean',
        group: 'catalog',
        initial: 'true',
        labelUz: 'Rasmsiz tovarga kategoriya ikonkasi',
        labelRu: 'Иконка категории для товара без фото',
        isPublic: true,
    },
    // --- qidiruv ---
    {
        key: 'search.min_score',
        valueType: 'number',
        group: 'search',
        initial: '0.35',
        labelUz: 'Qidiruvning eng past bahosi',
        labelRu: 'Минимальный балл поиска',
    },
    {
        key: 'search.log_empty_queries',
        valueType: 'boolean',
        group: 'search',
        initial: 'true',
        labelUz: 'Natijasiz so‘rovlarni yozish',
        labelRu: 'Записывать запросы без результатов',
        hintUz: 'Assortiment rejasi shu jurnaldan chiqadi.',
        hintRu: 'План ассортимента строится по этому журналу.',
    },
    // --- garaj ---
    {
        key: 'garage.recommendation_min_tag_coverage',
        valueType: 'number',
        group: 'garage',
        initial: '0.7',
        labelUz: 'Tavsiya uchun eng kam teg qamrovi',
        labelRu: 'Минимальное покрытие тегами для рекомендаций',
        hintUz: 'Faol tovarlarning shuncha ulushida model tegi bo‘lsagina tavsiya yoqiladi.',
        hintRu: 'Рекомендации включаются, только если у такой доли товаров есть тег модели.',
    },
];
const DEFINITIONS_BY_KEY = new Map(SETTING_DEFINITIONS.map((row) => [row.key, row]));
export function settingDefinition(key) {
    return DEFINITIONS_BY_KEY.get(key) ?? null;
}
/** Mijoz ilovasiga beriladigan kalitlar — ANIQ ro'yxat. */
export const PUBLIC_SETTING_KEYS = SETTING_DEFINITIONS.filter((row) => row.isPublic === true).map((row) => row.key);
export const SettingResponseSchema = z.object({
    key: z.string(),
    value: z.string(),
    valueType: SettingValueTypeSchema,
    group: z.string(),
    labelUz: z.string(),
    labelRu: z.string(),
    hintUz: z.string().nullable(),
    hintRu: z.string().nullable(),
    isPublic: z.boolean(),
    updatedAt: IsoDateTimeSchema,
});
export const UpdateSettingSchema = z.object({ value: z.string().max(2000) }).strict();
/**
 * Qiymat turiga mos ekanini tekshiradi.
 *
 * Server ham, admin formasi ham SHU funksiyadan o'qiydi: "0.35" ni
 * `number` deb qabul qilish qoidasi ikki joyda yozilsa ular ajralib
 * ketardi.
 */
export function isValidSettingValue(valueType, value) {
    if (valueType === 'number')
        return /^-?\d+(?:\.\d+)?$/u.test(value.trim());
    if (valueType === 'boolean')
        return value === 'true' || value === 'false';
    return true;
}
//# sourceMappingURL=reference.js.map